import {BookOpen, GraduationCap, Hammer, Sigma} from 'lucide-react'

function Footer() {
  return (
    <footer className="mt-20 border-t border-[var(--line)] bg-gradient-to-b from-transparent to-black/40">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-8 h-8 rounded-lg bg-gradient-to-br from-emerald-400 to-cyan-400 flex items-center justify-center">
                <Sigma className="w-4 h-4 text-[#06281b]" strokeWidth={2.5} />
              </span>
              <span className="font-display font-semibold text-base">FunMathCalculator.com</span>
            </div>
            <p className="text-sm text-slate-400 leading-relaxed">
              A polished, single-page math playground built for visual intuition. Five fully interactive solvers covering geometry,
              fractions, arithmetic, and finance — every step shown, every formula copyable.
            </p>
          </div>

          <div>
            <h3 className="font-display text-sm font-semibold text-white mb-4 inline-flex items-center gap-2">
              <GraduationCap className="w-4 h-4 text-emerald-400" /> For Students
            </h3>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>Circle Circumference Formula Calculator (Step-by-Step)</li>
              <li>Mixed Fraction Calculator: Add, Subtract & Multiply Fractions</li>
              <li>Rounding Numbers Calculator with Snapping Number Line</li>
              <li>Instant Markdown copy or email the walkthrough to your inbox</li>
            </ul>
          </div>

          <div>
            <h3 className="font-display text-sm font-semibold text-white mb-4 inline-flex items-center gap-2">
              <BookOpen className="w-4 h-4 text-emerald-400" /> For Educators
            </h3>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>Trapezoid Area Formula & Calculator with Drag-Solve Blueprint</li>
              <li>Visual midsegment proof for classroom whiteboards</li>
              <li>Pizza Slicing Board to teach common denominators</li>
              <li>Sign in once to email step-by-step solutions to students</li>
            </ul>
          </div>

          <div>
            <h3 className="font-display text-sm font-semibold text-white mb-4 inline-flex items-center gap-2">
              <Hammer className="w-4 h-4 text-emerald-400" /> For Makers & DIY
            </h3>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>Simple Interest Equation & Calculator (Stack Your Coins)</li>
              <li>Quick area & boundary checks for shop projects</li>
              <li>Copyable formulas for spec sheets and notebooks</li>
              <li>Snap to nearest 1s, 10s, 100s for cut-list rounding</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[var(--line)] flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-xs text-slate-500">
          <div>© {new Date().getFullYear()} FunMathCalculator.com — Visual intuition for everyday math.</div>
          <div className="font-mono-math">C = 2πr · A = ((a+b)/2)·h · I = Prt</div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
